// @ts-ignore
import React from "react";

import { FourOhFourPageTemplate } from "@/templates/404/404-page/src/404-page.template";

export const FourOhFourPage = () => <FourOhFourPageTemplate />;
